import { Grid, Stack, Typography, CircularProgress, Paper, Chip } from "@mui/material";
import CaseHistoryCard from "./CaseHistoryCard";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { useState, useEffect } from "react";

const API_HOST = CONFIG.modules['crm'].host;


const CaseDetailsHistory = ({ caseData }) => {

  const [caseHistory, setCaseHistory] = useState([]);
  const [loadingCaseHistory, setLoadingCaseHistory] = useState(true);
  /**
   * Api call to get case history
   */
  const getCaseHistory = async () => {
    try {
      const response = await axios.get(`${API_HOST}/case/related-cases/${caseData.motherID}`);
      setCaseHistory(response.data.cases);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCaseHistory(false);
    }
  };

  useEffect(() => {
    getCaseHistory();
  }, [caseData]);

  return (
    <Stack>
      <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} px={2} pt={1}>
        <Typography variant="h6">Case History</Typography>
        {/* <Button variant="contained" color="primary">Add Case</Button> */}
      </Stack>
      {
        loadingCaseHistory ? (
          <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <CircularProgress />
          </Stack>
        ) : (
          <Stack mx={2} my={2} spacing={2}> {/* Added spacing */}
            <Grid container spacing={2}> {/* Added spacing */}
              {caseHistory.map((caseD) => (
                <Grid item xs={12} sm={6} md={4} key={caseD._id}>
                  <CaseHistoryCard
                    caseData={caseD}
                    isCurrent={caseD._id === caseData._id} // Check if it's the current case
                    isCompleted={caseD.completed} // Pass completed status
                    hasBadData={caseD.badData} // Pass badData status
                  />
                </Grid>
              ))}
            </Grid>
          </Stack>
        )
      }
    </Stack >
  );
};


export default CaseDetailsHistory;
